import { axiosInstance } from "@/helper/axios-instance";
import type { DataAwareResponse, UniquePossibilities } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useNPVSettingsUpsert() {
  return useMutationWithValidation({
    mutationFn: async (data: { data: string; householdId: string | undefined }) => {
      const response = await axiosInstance({
        method: "POST",
        url:  `Household/UpsertNPVSettings`,
        data,
      });

      return response.data as DataAwareResponse<UniquePossibilities>;
    },
    retry: 2,
  });
}
